import React, { useRef, useState } from "react";
import styles from "./academic-view.module.css";
import { Button, Col, Row, Typography } from "antd";
import CustomButton from "../../../../../common/custom-button/custom-button";
import SVGIcon from "../../../../../constants/SVGIcon";
import SubjectsClassesStatCard from "../../../../../components/subjects-classes-stat-card/subjects-classes-stat-card";
import AddButtonExpanded from "../../../../../components/add-button-expanded/add-button-expanded";
import AddEditSection from "../add-edit-section/add-edit-section";
import CreateRoutine from "../create-routine/create-routine";
import CustomTextfield from "../../../../../common/input/custom-textfield/custom-textfield";
import { CheckOutlined } from "@ant-design/icons";
import { updateLevel } from "../../../../../services/student";
import { deleteClassroom } from "../../../../../services/class_routine";
import { fetchRoutineByRoutineId } from "../../../../../services/class_routine";
import EmptyLoader from "../../../../../components/emptyloader/emptyloader";

const AcademicView = ({ loading, classList, getInstitutionSummary }) => {
  const [showModal, setShowModal] = useState({ status: false, modalFor: "" });
  const [editSectionData, setEditSectionData] = useState(null);
  const [showEditLevel, setShowEditLevel] = useState(null);

  const [editRoutine, setEditRoutine] = useState(null);
  const [levelInfo, setLevelInfo] = useState({
    classroom_id: "",
  });
  const inputRef = useRef(null);

  const TYPE = {
    SECTION: "Section",
    ROUTINE: "Routine",
  };

  const handleCreateRoutine = (child) => {
    setShowModal({ status: true, modalFor: TYPE.ROUTINE });
    setLevelInfo({ classroom_id: child?.classroom_id });
  };
  const handleEdit = (data) => {
    setEditSectionData(data);
    setShowModal({ status: true, modalFor: TYPE.SECTION });
  };

  const handleDelete = async (data) => {
    try {
      await deleteClassroom(data?.classroom_id);
      getInstitutionSummary();
    } catch (err) {
      console.log(err);
    }
  };

  const onCloseAddEdit = () => {
    setShowModal({ status: false, modalFor: TYPE.SECTION });
    getInstitutionSummary();
  };

  const onClickCreateForm = () => {
    setEditSectionData(null);
    setShowModal({ status: true, modalFor: TYPE.SECTION });
  };

  const handleAddSection = (level_name) => {
    setEditSectionData({ level_name });
    setShowModal({ status: true, modalFor: TYPE.SECTION });
  };

  const handleEditRoutine = async (child) => {
    try {
      const resp = await fetchRoutineByRoutineId(child?.classroom_id);

      const data = resp?.data?.data?.schedulesByDay;

      const itemObj = Object.values(data)?.[0]?.[0];
      const obj = {};

      Object.entries(data).forEach((item) => {
        const [day, schedules] = item;

        obj[day] = schedules?.map((item) => {
          return {
            subject: item?.subject_info?.[0]?.subject_id,
            teacher: item?.subject_info?.[0]?.teacher_id,
            startTime: item?.start_time,
            endTime: item?.end_time,
          };
        });
      });
      const constructData = {
        routine_name: itemObj?.routine_name,
        section_name: itemObj?.classroom_id,
        routine_id: child?.routine_id,
        ...obj,
      };

      setLevelInfo({ classroom_id: itemObj?.classroom_id });
      setEditRoutine(constructData);
      setShowModal({ status: true, modalFor: TYPE.ROUTINE });
    } catch (err) {
      console.log(err);
    }
  };

  const menuItems = (child) => {
    return [
      {
        label: child?.routine_id ? "Edit Routine" : "Create Routine",
        onClick: child?.routine_id
          ? handleEditRoutine.bind(null, child)
          : handleCreateRoutine.bind(null, child),
      },
      { label: "Edit Section", onClick: handleEdit },
      { label: "Delete Section", onClick: handleDelete },
    ];
  };

  const handleEditLevel = (item) => {
    setShowEditLevel({
      level_id: item?.level_id,
      level_name: item?.level_name,
    });
    const timeout = setTimeout(() => {
      inputRef.current?.focus();
      clearTimeout(timeout);
    }, 0);
  };

  const handleClick = async () => {
    try {
      if (
        showEditLevel ||
        !!showEditLevel?.level_id ||
        !!showEditLevel?.level_name
      ) {
        await updateLevel(showEditLevel.level_id, {
          name: showEditLevel?.level_name,
        });
        setShowEditLevel(null);
        await getInstitutionSummary();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className={styles.levels_container}>
      <div className={styles.title_button}>
        <Typography className={styles.title}>Student By Level</Typography>
        <CustomButton
          title="Create Form"
          size="large"
          icon={
            <SVGIcon
              name="add-icon"
              width="24"
              height="24"
              className="anticon"
              stroke="#FFF"
            />
          }
          onClick={onClickCreateForm}
        />
      </div>

      <EmptyLoader loading={loading} isDataAvailable={classList?.length} />

      {classList?.map((item, index) => (
        <div className={styles.level_data} key={index}>
          <Typography className={styles.title}>
            {item?.level_id === showEditLevel?.level_id ? (
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  columnGap: 10,
                }}
              >
                <CustomTextfield
                  ref={inputRef}
                  onBlur={(e) => {
                    if (e.relatedTarget?.id !== "submit-btn") {
                      setShowEditLevel(null);
                    }
                  }}
                  value={showEditLevel.level_name}
                  onChange={(e) =>
                    setShowEditLevel((pre) => ({
                      ...pre,
                      level_name: e.target.value,
                    }))
                  }
                />
                <Button
                  type="primary"
                  onClick={handleClick}
                  shape="circle"
                  id="submit-btn"
                  style={{ height: 30, width: 30, borderRadius: "100%" }}
                  icon={<CheckOutlined />}
                />
              </div>
            ) : (
              <div
                style={{ display: "inline-flex" }}
                onClick={() => handleEditLevel(item)}
              >
                <SVGIcon
                  name={"pencil-hollow"}
                  width={"24"}
                  height={"16"}
                  className="anticon"
                  style={{ cursor: "pointer" }}
                  stroke={"#000"}
                />
                LEVEL {item?.level_name}
              </div>
            )}
          </Typography>
          <Row gutter={[16, 16]}>
            {item?.classrooms?.map((child, child_index) => (
              <Col
                flex="1 0 250px"
                className={styles.nonacademic_data}
                key={child_index}
              >
                <SubjectsClassesStatCard
                  data={{ ...child, level_name: item?.level_name }}
                  total_male={child?.male_students}
                  total_female={child?.female_students}
                  total_teachers={child?.teacher_count}
                  routine={child?.routine_name}
                  class_name={child?.classroom_name}
                  menuItems={menuItems(child)}
                  total_students={child?.total_students}
                  capacity={child?.occupied_seats}
                  max_capacity={child?.capacity}
                  colour_code={child?.colour_code}
                />
              </Col>
            ))}
            <Col flex="1 0 250px" className={styles.add_section}>
              <div style={{ width: "100%", height: "100%" }}>
                <AddButtonExpanded
                  onClick={() => handleAddSection(item?.level_name)}
                  buttonLabel="Add Section"
                />
              </div>
            </Col>
          </Row>
        </div>
      ))}
      {showModal?.status && showModal?.modalFor === TYPE.SECTION && (
        <AddEditSection
          onClose={onCloseAddEdit}
          open={showModal}
          editSectionData={editSectionData}
        />
      )}
      {showModal?.status && showModal?.modalFor === TYPE.ROUTINE && (
        <CreateRoutine
          onClose={() => {
            setShowModal({ status: false, modalFor: TYPE.ROUTINE });
            setEditRoutine(null);
          }}
          open={showModal}
          editRoutine={editRoutine}
          levelInfo={levelInfo}
          getInstitutionSummary={getInstitutionSummary}
        />
      )}
    </div>
  );
};

export default AcademicView;
